import React from 'react';
// javascript plugin used to create scrollbars on windows
// import PerfectScrollbar from "perfect-scrollbar";
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
// import { withAuthentication } from '../components/Session';

//import AdminNavbar from "components/Navbars/userNavbar.jsx";

import Footer from '../components/Footer/Footer';
// import FixedPlugin from "components/FixedPlugin/FixedPlugin.jsx";

import getProfileRoutes from '../routes.js';
import subroutes from '../subroutes.js';

class UserLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      backgroundColor: 'black',
      activeColor: 'info',
      sidebarMini: false,
      routes: getProfileRoutes(), // getProfileRoutes(this.props.profile.customer.federations[0], this.props.profile.userprofile.role)
    };
  }

  componentDidMount() {
    /*
    if (navigator.platform.indexOf("Win") > -1) {
      document.documentElement.className += " perfect-scrollbar-on";
      document.documentElement.classList.remove("perfect-scrollbar-off");
      ps = new PerfectScrollbar(this.refs.mainPanel);
    }
    */
  }
  componentWillUnmount() {
    /*
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
      document.documentElement.className += " perfect-scrollbar-off";
      document.documentElement.classList.remove("perfect-scrollbar-on");
    }
    */
  }
  componentDidUpdate(e) {}

  getCompProps = (type, properties) => {
    var Type = type;
    return <Type {...properties} />;
  };

  getComp = (type) => {
    var Type = type;
    return <Type />;
  };

  getSubRoutes = (subroutes) => {
    return subroutes.map((prop, key) => {
      const RouteComponent = prop.component
      return (
        <Route
          path={prop.layout + prop.path}
          element={<RouteComponent {...this.props} />}
          key={key}
        />
      );
    });
  };

  getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return this.getRoutes(prop.views);
      }
      if (prop.layout === '/user') {
        const RouteComponent = prop.component
        return (
          <Route
            path={prop.layout + prop.path}
            element={<RouteComponent {...this.props} />}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  render() {
    // console.log(this.props);
    const profileRoutes = this.state.routes;
    if (profileRoutes) {
      // console.log(profileRoutes);
      return (
        <div className='wrapper wrapper-full-page'>
          <div className='full-page section-image'>
            <div className='login-page'>
              <Routes>
                {this.getRoutes(profileRoutes)}
                {this.getSubRoutes(subroutes)}
                <Route path="/" element={<Navigate to="/user/main" replace />} />
              </Routes>
              <UserLayoutFooter />
              <div
                className='full-page-background'
                style={{
                  backgroundImage: `url(${require('../assets/img/bg/miguel-perales.jpg')})`,
                }}
              />
            </div>
          </div>
        </div>
      );
    } else {
      return <></>;
    }
  }
}

// Wrapper component to access location in functional style
function UserLayoutFooter() {
  const location = useLocation()
  if (location.pathname.indexOf('full-screen-map') !== -1) {
    return null
  }
  return <Footer fluid />
}

export default UserLayout;
